import { toQueryParams } from "utils/http/params";
import { dataApi } from "./DataService";
import { isoToDateString, isoToDateTimeString, isoToTimeString, toIsoStringFromString } from "utils/date";
import { isoToDate } from "utils/date/isoToDate";
import { patchQueries } from "rtkq/patchQueries";
import { markEndpointStale } from "rtkq/staleManager";
import { getQueryCacheKey } from "rtkq/getQueryCacheKey";

const makeEditItemAction = (api, id, data, queryName) => {
  return api.util.updateQueryData(queryName, {id}, (draft) => {
    draft.body.items = data;
  });
};


const deviceApi = dataApi
  .enhanceEndpoints({})
  .injectEndpoints({
    endpoints: (builder) => ({

      getDevices: builder.query({
        query: (arg) => ({
          url: '/devices',
          params: toQueryParams(arg)
        })
      }),

      updateDevice: builder.mutation({
        
        query: ({id, body}) => ({
          url: `/devices/${encodeURIComponent(id)}`,
          method: 'PATCH',
          body: body
        }),

        async onQueryStarted( {id, body, currentQueryArgs}, {dispatch, queryFulfilled} ) { 
          
          const result = dispatch(
            deviceApi.util.updateQueryData('getDevices', currentQueryArgs, (draft) => { 
              const item = draft?.body?.items.find(el => el.id === id);
              item && Object.assign(item, body);
            })
          );

          try {
            const { data } = await queryFulfilled; 
            dispatch(
              deviceApi.util.updateQueryData('getDevices', currentQueryArgs, (draft) => {
                const item = draft?.body?.items.find(el => el.id === id);
                item && Object.assign(item, data.body);
              })
            );

            //если есть фильтрация + изменяемое поле в body задействовано при фильтрации, то обновляем и текущий кэш
            const currentCacheKey = getQueryCacheKey({endpointName: 'getDevices', queryArgs: currentQueryArgs, patchData: body});  
            dispatch(
              markEndpointStale({
                  endpointName: 'getDevices',
                  exceptCacheKey: currentCacheKey
              })
            );
          }
          catch {
            result.undo();
          }
        }
      }),

      getDeviceApps: builder.query({
        query: ({id}) => ({
          url: `/devices/${encodeURIComponent(id)}/apps`
        })
      }),

      updateDeviceApps: builder.mutation({
        query: ({devId, body}) => ({
          url: `/devices/${encodeURIComponent(devId)}/apps`,
          method: 'PUT',
          body: body, 
        }),
        async onQueryStarted({body, devId}, {dispatch, queryFulfilled}) {
          const result = dispatch(makeEditItemAction(deviceApi, devId, body, 'getDeviceApps'));
          try {
            await queryFulfilled;
          }
          catch {
            result.undo();
          }
        }
      }),

      getDeviceLics: builder.query({
        query: ({id}) => ({
          url: `/devices/${encodeURIComponent(id)}/lics`
        })
      }),

      updateDeviceLics: builder.mutation({
        query: ({devId, body}) => ({
          url: `/devices/${encodeURIComponent(devId)}/lics`,
          method: 'PUT',
          body: body
        }),
        async onQueryStarted({body, devId}, {dispatch, queryFulfilled}) {
          const result = dispatch(makeEditItemAction(deviceApi, devId, body, 'getDeviceLics'));
          try {
            await queryFulfilled;
          }
          catch {
            result.undo();
          }
        }
      }),

      getDevicePrefs: builder.query({
        query: ({id}) => ({
          url: `/devices/${encodeURIComponent(id)}/preferences`
        })
      }),

      updateDevicePrefs: builder.mutation({
        query: ({devId, body}) => ({
          url: `/devices/${encodeURIComponent(devId)}/preferences`,
          method: 'PUT',
          body: body
        }),
        async onQueryStarted({body, devId}, {dispatch, queryFulfilled}) {
          const result = dispatch(
            deviceApi.util.updateQueryData('getDevicePrefs', {id: devId}, (draft) => { 
              draft.body = body;
            })
          );
          try {
            await queryFulfilled;
          }
          catch {
            result.undo();
          }
        }
      }),

      getDeviceLog: builder.query({
        query: ({id, ...others}) => ({
          url: `/devices/${encodeURIComponent(id)}/log`,
          params: toQueryParams(others)
        })
      }),

    })  
  });

  export const {
    useGetDevicesQuery,
    useUpdateDeviceAppsMutation,
    useGetDeviceAppsQuery,
    useUpdateDeviceLicsMutation,
    useGetDeviceLicsQuery,
    useGetDeviceLogQuery,
    useGetDevicePrefsQuery,
    useUpdateDevicePrefsMutation,
    useUpdateDeviceMutation,
  } = deviceApi;